import { gql } from '@apollo/client';
import { CLAIM_FIELDS } from '../../fragments';
import { GetUserClaimsProps } from './claim.types';
import { UserClaim } from '../../../types/User.types';

export const GET_USER_CLAIMS = gql`
  ${CLAIM_FIELDS}
  query GetUserClaims($email: String!) {
    getUserClaims(email: $email) {
      ...ClaimFields
    }
  }
`;

export function getUserClaims({ client, email }: GetUserClaimsProps) {
  return client?.watchQuery<{ getUserClaims: UserClaim[] }>({
    query: GET_USER_CLAIMS,
    variables: {
      email,
    },
  });
}
